export default "__VITE_ASSET__lsHErM4E__"